<template>
  <section>
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto">
          <v-btn
            class="accent shadow-4 px-8"
            large
            rounded
            @click="isFormOpen = true"
          >
            Añadir Pausa
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="deep-purple lighten-4 elevation-0"
                fab
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="deep-purple"> mdi-tray-arrow-down </v-icon>
                <!-- Descargar -->
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="selectDate(0)">
                <v-list-item-title> Reporte resumido </v-list-item-title>
              </v-list-item>
              <v-list-item @click="selectDate(1)">
                <v-list-item-title> Reporte detallado </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="breaks"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <!-- :page.sync="page"
                @page-count="pageCount = $event" -->
        <template v-slot:[`item.is_documentation`]="{ item }">
          {{ item.is_documentation ? "Documentación" : "Normal" }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                color="transparent"
                small
                @click="changeStatus(item)"
              >
                <v-icon left small :color="item.status ? 'success' : 'error'"
                  >mdi-radiobox-marked</v-icon
                >
                {{ item.status ? "Habilitado" : "Inactivo" }}
              </v-chip>
            </template>
            <span>Cambiar estado</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleEdit(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteBreak(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal de fecha -->
    <v-dialog v-model="activeDateModal" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Seleccione fecha
              </v-card-title>
            </v-img>
          </v-card-title>
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense justify="center">
                <v-col cols="12">
                  <regular-date-range-picker @dates:change="getRangeDates" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="activeDateModal = false"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading || date == ''"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(downloadTodayCsv)"
              >
                Descargar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <breaks-dialog
      :active="isFormOpen"
      :isEdit="!!breakToEdit"
      :data="breakToEdit"
      @dialog:close="closeForm"
    ></breaks-dialog>
  </section>
</template>

<script>
import moment from "moment";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
import RegularDateRangePicker from "../DatePickers/RegularDateRangePicker.vue";
import BreaksDialog from "./BreaksDialog.vue";

export default {
  components: {
    RegularDateRangePicker,
    BreaksDialog,
  },

  data() {
    return {
      isLoading: false,
      isFormOpen: false,
      activeDateModal: false,
      dateMenu: false,
      search: "",
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Cantidad",
          value: "quantity",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Tiempo",
          value: "time",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Tipo",
          value: "is_documentation",
          class: "primary--text",
          width: "12%",
        },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      breakToEdit: null,
      reportType: null,
      date: new moment().format("YYYY-MM-DD"),
      payload: {},
    };
  },

  async created() {
    await this.getBreaks();
  },

  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_ALL_BREAKS"];
    },
  },

  methods: {
    getRangeDates(dates) {
      this.payload.date = dates[0];
      this.payload.dateEnd = dates[1];
    },

    selectDate(type) {
      this.reportType = type;
      this.activeDateModal = true;
    },

    async downloadTodayCsv() {
      this.isLoading = true;

      const payload = {
        type: this.reportType,
        payload: this.payload,
      };

      try {
        await CdrDownloadToCsv(payload, "ShowBreaks");

        this.isLoading = false;
        this.activeDateModal = false;
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    },

    async getBreaks() {
      try {
        await this.$store.dispatch("breaks/SHOW_BREAKS");
      } catch (error) {
        console.log(error);
      }
    },
    closeForm() {
      this.isFormOpen = false;
      this.breakToEdit = null;
    },
    handleEdit(item) {
      this.breakToEdit = item;
      this.isFormOpen = true;
    },
    async deleteBreak(item) {
      await this.$store.dispatch("breaks/DELETE_BREAKS", {
        id: item.id,
      });
    },
    async changeStatus(item) {
      const enviar = {
        data: {
          status: item.status === 1 ? 0 : 1,
        },
        id: item.id,
      };
      await this.$store.dispatch("breaks/EDIT_BREAKS", enviar);
    },
  },
};
</script>

<style></style>
